// @ts-nocheck 5bc7ea53
import * as stateManagement from '#packages/stateManagement';
const uploadedFontsSelectors = stateManagement.uploadedFonts.selectors;

const mapEditorAPIToThemeFontsLoader = ({ state }) => ({
  uploadedFontsList: uploadedFontsSelectors.getList(state),
});

export default mapEditorAPIToThemeFontsLoader;
